import React, { useState, useEffect } from "react";
// import Header from "../components/header/header";
import Footer from "../components/footer/footer";
import { api, s3Url } from "../service/api.service";
import { Link } from "react-router-dom";

export default function Books() {
  const [loading, setLoading] = useState(false);
  const [books, setBooks] = useState([]);
  //----------------------------------------
  // API
  //----------------------------------------

  useEffect(() => {
    fetchBooks();
  }, []);

  const fetchBooks = async () => {
    try {
      setLoading(true);

      const response = await fetch(`${api.defaults.baseURL}books/all`, {
        headers: {
          Accept: "application/json",
        },
      });

      const json = await response.json();
      const enabledBooks = (json.data || []).filter((book) => book.enabled === true);

      setBooks(enabledBooks);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section className="bg-[#fff8f4] min-h-screen py-28 md:py-28 lg:py-32">
        <div className="max-w-7xl mx-auto px-4">
          <h1 className="text-center text-3xl sm:text-4xl lg:text-5xl font-bold mb-6 lg:mb-10">
            Books
          </h1>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {books.map((book) => (
              <div
                key={book._id}
                className="bg-white rounded-2xl overflow-hidden shadow-lg"
              >
                <img
                  src={`${s3Url}${book.imageURL}`}
                  alt={book.title}
                  className="w-full h-auto object-contain"
                />

                <div className="p-5">
                  <h2 className="text-xl font-semibold">{book.title}</h2>

                  {book.author && book.author !== "." && (
                    <p className="mt-2 text-sm text-gray-600">{book.author}</p>
                  )}

                  <Link
    to={`/books/index/${book._id}`}
    className="inline-flex items-center justify-center mt-4 rounded-full bg-[#1d4f91] px-4 py-2 text-sm font-semibold text-white transition duration-200 hover:bg-[#163d73]"
  >
    Read Book <span className="ml-2">→</span>
  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
